import type { Attachment, JobImage } from 'src/shared/graphql/generated';

type LabelData = {
  collectionIndex: number;
  collectionNumber: number;
  labelType: 'original' | 'rendering';
};
/* Quality of life class to encapsulate Attachments and Job Images */
class ImageLike {
  image: Attachment | JobImage;

  labelData: LabelData;

  constructor(image: Attachment | JobImage, labelData?: LabelData) {
    this.image = image;
    this.labelData = labelData ?? {
      collectionIndex: 1,
      collectionNumber: 1,
      labelType: 'rendering',
    };
  }

  /*
   * Only used for component key values.  I suppose there's some small chance
   * these might be equal, but so there are separate `attachmentId` and
   * `jobImageId` for those uses.  But for component keys, this is fine.
   */
  get id() {
    return this.image.id;
  }

  get attachmentId() {
    // eslint-disable-next-line no-underscore-dangle
    if (this.image.__typename === 'Attachment') {
      return this.image.id || '';
    }
    return undefined;
  }

  get jobImageId() {
    // eslint-disable-next-line no-underscore-dangle
    if (this.image.__typename === 'JobImage') {
      return this.image.id || '';
    }
    return undefined;
  }

  get blobUrl() {
    // eslint-disable-next-line no-underscore-dangle
    if (this.image.__typename === 'Attachment') {
      return this.image.blobUrl || '';
    }
    return (this.image as JobImage).imageUrl || '';
  }

  get thumbUrl() {
    // eslint-disable-next-line no-underscore-dangle
    if (this.image.__typename === 'Attachment') {
      return this.image.thumbUrl || '';
    }
    return (this.image as JobImage).imageSmallUrl || '';
  }

  get type() {
    // eslint-disable-next-line no-underscore-dangle
    return this.image.__typename;
  }

  label(translate: (key: string) => string) {
    const translationKey =
      this.labelData.labelType === 'original'
        ? 'renderings.original'
        : 'renderings.image';

    return (
      `${translate(translationKey)} ${this.labelData.collectionNumber}.` +
      `${this.labelData.collectionIndex}`
    );
  }
}

export { ImageLike };
